import { 
  HomeIcon, BranchIcon, AccountsIcon, ConnectsIcon, 
  ManageSlipsIcon, ManageAdminIcon, ApiConnectIcon, 
  HistoryIcon, SettingsIcon, TeamIcon 
} from '@/components/dashboard/sidebar-icons'

export interface NavigationItem {
  name: string
  href: string
  icon: any
  isCustom?: boolean
  // RBAC fields
  requiredPermissions?: string[]        // Required permissions (OR logic)
  requiredPermissionsAll?: string[]     // Required permissions (AND logic)
  requiredRole?: string[]               // Required roles
  accountType?: 'customer' | 'system'   // Required account type
  disabledTooltip?: string              // Tooltip when disabled
}

export interface NavigationSection {
  title: string
  items: NavigationItem[]
  // RBAC fields for entire section
  requiredPermissions?: string[]
  accountType?: 'customer' | 'system'
}

export const customerNavigation: NavigationSection[] = [
  {
    title: "จัดการร้าน",
    accountType: "customer",
    items: [
      { 
        name: "หน้าแรก", 
        href: "/dashboard", 
        icon: HomeIcon, 
        isCustom: true,
        requiredPermissions: ["dashboard:view"],
        accountType: "customer"
      },
      { 
        name: "สาขา", 
        href: "/dashboard/branch", 
        icon: BranchIcon, 
        isCustom: true,
        requiredPermissions: ["branch:view"],
        accountType: "customer"
      },
      { 
        name: "บัญชีธนาคาร", 
        href: "/dashboard/accounts", 
        icon: AccountsIcon, 
        isCustom: true,
        requiredPermissions: ["accounts:view"],
        accountType: "customer"
      },
      { 
        name: "การเชื่อมต่อ", 
        href: "/dashboard/connects", 
        icon: ConnectsIcon, 
        isCustom: true,
        requiredPermissions: ["dashboard:view"],
        accountType: "customer"
      },
      { 
        name: "จัดการสลิป", 
        href: "/dashboard/slips-manage", 
        icon: ManageSlipsIcon, 
        isCustom: true,
        requiredPermissions: ["slip:verify"],
        accountType: "customer"
      },
      { 
        name: "จัดการแอดมิน", 
        href: "/dashboard/admin-manage", 
        icon: ManageAdminIcon, 
        isCustom: true,
        // Original permission: ["customer:update"]
        requiredPermissions: ["feature:coming_soon"],
        requiredRole: ["customer_manager", "customer_admin"],
        accountType: "customer"
      },
      { 
        name: "จัดการทีมงาน", 
        href: "/dashboard/team", 
        icon: TeamIcon, 
        isCustom: true,
        requiredPermissions: ["team:view"],
        requiredRole: ["owner", "admin"],
        accountType: "customer"
      },
    ],
  },
  {
    title: "API Connect",
    accountType: "customer",
    items: [
      { 
        name: "API Keys", 
        href: "/api-connect/auth", 
        icon: ApiConnectIcon, 
        isCustom: true,
        requiredPermissions: ["api:use"],
        accountType: "customer",
        disabledTooltip: "ฟีเจอร์นี้สำหรับ Premium Package ขึ้นไป เท่านั้น"
      },
      { 
        name: "API Endpoint", 
        href: "/api-connect/endpoint", 
        icon: ApiConnectIcon, 
        isCustom: true,
        requiredPermissions: ["api:use"],
        accountType: "customer",
        disabledTooltip: "ฟีเจอร์นี้สำหรับ Premium Package ขึ้นไป เท่านั้น"
      },
      { 
        name: "Response", 
        href: "/api-connect/response", 
        icon: ApiConnectIcon, 
        isCustom: true,
        requiredPermissions: ["api:use"],
        accountType: "customer",
        disabledTooltip: "ฟีเจอร์นี้สำหรับ Premium Package ขึ้นไป เท่านั้น"
      },
    ],
  },
  {
    title: "ประวัติการใช้งาน",
    accountType: "customer",
    items: [
      { 
        name: "ประวัติการตรวจสอบ", 
        href: "/history/checks", 
        icon: HistoryIcon, 
        isCustom: true,
        requiredPermissions: ["reports:view"],
        accountType: "customer"
      },
      { 
        name: "ประวัติ API Connect", 
        href: "/history/api", 
        icon: HistoryIcon, 
        isCustom: true,
        requiredPermissions: ["api:view"],
        accountType: "customer"
      },
      { 
        name: "ประวัติการใช้งานทั้งหมด", 
        href: "/history/all", 
        icon: HistoryIcon, 
        isCustom: true,
        requiredPermissions: ["billing:view"],
        accountType: "customer"
      },
    ],
  },
  {
    title: "การตั้งค่า",
    accountType: "customer",
    items: [
      { 
        name: "ตั้งค่าการตรวจสลิป", 
        href: "/settings/slip-checks", 
        icon: SettingsIcon, 
        isCustom: true,
        // Original permission: ["dashboard:view"]
        requiredPermissions: ["feature:coming_soon"],
        accountType: "customer"
      },
      { 
        name: "ตั้งค่าแพ็กเกจ", 
        href: "/settings/packages", 
        icon: SettingsIcon, 
        isCustom: true,
        requiredPermissions: ["billing:view"],
        accountType: "customer"
      },
      { 
        name: "ตั้งค่าบัญชี", 
        href: "/settings/accounts", 
        icon: SettingsIcon, 
        isCustom: true,
        // Original permission: ["dashboard:view"]
        requiredPermissions: ["feature:coming_soon"],
        accountType: "customer"
      },
    ],
  },
]
